export default __webpack_public_path__ + "static/media/footer-logo.ff7c438a.svg";